import { render, staticRenderFns } from "./formVipGrade.vue?vue&type=template&id=a13bdb5c&scoped=true&"
import script from "./formVipGrade.vue?vue&type=script&lang=js&"
export * from "./formVipGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13bdb5c",
  null
  
)

export default component.exports